import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaRocket, FaMobileAlt, FaUsers, FaGraduationCap, FaHandsHelping } from 'react-icons/fa';

const FuturePlans = () => {
    const { t } = useTranslation();

    const plans = [
        {
            icon: <FaRocket />,
            textKey: 'futurePlans.point1',
        },
        {
            icon: <FaMobileAlt />,
            textKey: 'futurePlans.point2',
        },
        {
            icon: <FaUsers />,
            textKey: 'futurePlans.point3',
        },
        {
            icon: <FaGraduationCap />,
            textKey: 'futurePlans.point4',
        },
        {
            icon: <FaHandsHelping />,
            textKey: 'futurePlans.point5',
        }
    ];

    return (
        <section className="py-20 bg-white relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16 max-w-3xl mx-auto">
                    <span className="text-secondary font-bold tracking-widest uppercase text-xs mb-3 block">{t('futurePlans.roadmapBadge')}</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6">
                        {t('futurePlans.title')}
                    </h2>
                    <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
                    <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
                        {t('futurePlans.subtitle')}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center">
                    {plans.map((plan, index) => (
                        <div
                            key={index}
                            className="bg-gray-50 rounded-lg p-6 border-l-4 border-secondary shadow-sm hover:shadow-md transition-all duration-300 hover:bg-white group"
                        >
                            <div className="flex items-center gap-4">
                                <div
                                    className="w-12 h-12 rounded-lg flex items-center justify-center text-xl bg-white text-primary border border-gray-200 group-hover:border-secondary group-hover:text-secondary transition-all duration-300 shadow-sm"
                                >
                                    {plan.icon}
                                </div>
                                <div className="flex-1">
                                    <p className="text-gray-800 font-semibold text-lg leading-relaxed group-hover:text-primary-dark transition-colors">
                                        {t(plan.textKey)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FuturePlans;
